<ng-container *ngIf="address && address?.address1 else showEmpty">
  <p class="kendo-caption-body" *ngIf="address?.address1 || address?.address2 || address?.address3">{{address?.address1 && address?.address2 ? address?.address1 + ' ' : address?.address1 + ''}}{{(address?.address2 && address?.address3) ? address?.address2 + address?.address3 + ',' : address?.address2 ? address?.address2 + ',' : ','}}</p>
  <p class="kendo-caption-body">{{address.city}}, {{address.state}}</p>
  <p class="kendo-caption-body" [innerHTML]="address.postal"></p>
  <p class="kendo-caption-body" [innerHTML]="address.country"></p>
</ng-container>
<ng-template #showEmpty>
  <p class="kendo-caption-body">-</p>
</ng-template>